import React from 'react';
import CustomSection from '../../custom-general/custom-section';
import Image from '../../../blocks/report-image/image';
import classNames from './style.module.scss';

import { concatClassNames, getWallThicknessValue } from '../../../../utils/utilities';
import { AutScanDataItem } from '../../../../utils/models';

interface ScanDataProps {
	scanDataItems: AutScanDataItem[];
}

const ScanData: React.FC<ScanDataProps> = ({ scanDataItems }) => {
	return (
		<>
			{scanDataItems.map((scanDataItem) => (
				<CustomSection sectionTitle="Scan Image" sectionSubtitle={scanDataItem.zoneName} key={scanDataItem.zoneName}>
					<div className={classNames.scanDataImage}>
						{scanDataItem.scanImage.length > 0 ? (
							<img src={scanDataItem.scanImage[0].src} alt={scanDataItem.scanImage[0].caption} />
						) : null}
					</div>
					<div className={classNames.scanDataSummary}>
						<div className="container-fluid">
							<div className="row">
								<div className="col-7 p-0">
									<div className={classNames.scanDataSummaryTitleWarning}>
										Scan Summary - Minimum Thickness Spot Details
									</div>
									<div className="table-responsive">
										<table className={classNames.scanDataSummaryTable}>
											<thead>
												<tr>
													<th rowSpan={2}>Zone Number</th>
													<th colSpan={2}>Scan Area</th>
													<th rowSpan={2}>Nominal Thickness</th>
													<th rowSpan={2}>Corrosion Allowance</th>
												</tr>
												<tr>
													<th>Axial Length</th>
													<th>Circ. Length</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td rowSpan={2}>{scanDataItem.zoneName}</td>
													<td rowSpan={2}>{scanDataItem.axialLength}</td>
													<td rowSpan={2}>{scanDataItem.circLength}</td>
													<td rowSpan={2}>{scanDataItem.nominalThickness}</td>
													<td rowSpan={2}>{scanDataItem.corrosionAllowance}</td>
												</tr>
											</tbody>
										</table>
										<table className={classNames.scanDataSummaryTable}>
											<thead>
												<tr>
													<th colSpan={4}>Minimum Thickness and Location</th>
												</tr>
												<tr>
													<th>Min. Thickness (mm)</th>
													<th>Wall Thickness Loss (%)</th>
													<th>Axial Loc.</th>
													<th>Circ. Loc.</th>
												</tr>
											</thead>

											<tbody>
												<tr>
													<td rowSpan={2}>{scanDataItem.minimumThickness}</td>
													<td rowSpan={2}>{getWallThicknessValue(scanDataItem.nominalThickness, scanDataItem.minimumThickness).toFixed(2)}</td>
													<td rowSpan={2}>{scanDataItem.axialLoc}</td>
													<td rowSpan={2}>{scanDataItem.circLoc}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="container-fluid">
										<div className={concatClassNames([classNames.scanDataLimitation, 'row'])}>
											<div className={concatClassNames([classNames.scanDataLimitationTitle, 'col-3'])}>
												Limitation / Comment (If any)
											</div>
											<div className={concatClassNames([ 	classNames.scanDataLimitationValue, 'col'])}>
												{scanDataItem.limitation}
											</div>
										</div>
									</div>
								</div>
								<div className={concatClassNames([classNames.scanDataSummary, 'col p-0'])}>
									<div className={classNames.scanDataSummaryTitleWarning}>
										Scan Area
									</div>
									<div className={classNames.scanDataSummaryScanArea}>
										<Image src={scanDataItem.scanArea[0].src} alt={scanDataItem.scanArea[0].caption} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</CustomSection>
			))}
		</>
	);
};

export default ScanData;
